export const PRODUCT_NAME = 'MDS'
export const PRODUCT_TAGLINE = 'Mission Design System'
export const OPERATOR = {
  name: 'MetaPhase',
  url: 'https://metaphase.tech',
} as const
export const DELIVERY =
  'The design system for United States government websites, built by MetaPhase.'
export const ATTRIBUTION =
  'Mission Design System is built and operated by MetaPhase.'
export const BUILT_BY = `Built by ${OPERATOR.name}`
export const COPYRIGHT_YEAR = 2026
